const styles = () => ({
  containerModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: " 90%",
    maxWidth: "463px",
    bgcolor: "background.paper",
    boxShadow: 24,
    overflow: "hidden",
    height: "600px",
  },
  boxImg: {
    width: "101%",
    display: "block",
    overflow: "hidden",
    flexShrink: 0,
    flexGrow: 0,
    ml: -0.5,
  },
  boxComponent: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    p: 2,
  },
  containerButtons: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px",
    marginTop: "60px",
  },
  containerQuestion: {
    width: "100%",
    p: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
  },
  containerDescriptionQuestion: {
    width: "100%",
    display: "flex",
    alignItems: "start",
  },
  containerChipsSelect: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    padding: "8px",
    alignItems: "center",
    justifyContent: "center",
  },
  containerButtons: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px",
  },
});

export default styles;
